import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DraftPropertyListDto } from '@workspace/data-types';
import { PropertyDraftCardSkeletonComponent } from '../property-draft-card-skeleton/property-draft-card-skeleton.component';
import { PropertyDraftCardComponent } from '../property-draft-card/property-draft-card.component';

@Component({
  selector: 'etxe-property-draft-list',
  imports: [CommonModule, MatIconModule, PropertyDraftCardComponent, PropertyDraftCardSkeletonComponent],
  templateUrl: './property-draft-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyDraftListComponent {
  drafts = input.required<DraftPropertyListDto[]>();
  loading = input<boolean>(false);

  draftSelected = output<DraftPropertyListDto>();
  draftDeleted = output<DraftPropertyListDto>();
}
